// extracted by mini-css-extract-plugin
module.exports = {"isVerified":"VerificationSign_isVerified__3JMxe","tooltip":"VerificationSign_tooltip__3bouS","confirmed":"VerificationSign_confirmed__2q8gW"};